import { useEffect, useState } from 'react';

export const useResizeObserver = (ref) => {
    const [width, setWidth] = useState(0);

    useEffect(
        () => {
            const element = ref?.current;
            if (!element) return;

            const updateWidth = () => {
                const newWidth = element.offsetWidth;
                setWidth(newWidth);
                document.documentElement.style.setProperty(
                    '--container-width',
                    `${newWidth}px`
                );
            };

            updateWidth();

            if (typeof ResizeObserver !== 'undefined') {
                const observer = new ResizeObserver(() => updateWidth());
                observer.observe(element);

                return () => observer.disconnect();
            } else {
                // Fallback for old browsers IE, Safari before 13.1
                window.addEventListener('resize', updateWidth);
                return () => window.removeEventListener('resize', updateWidth);
            }
        },
        [ref]
    );

    return width;
};
